import { computed, inject, Injectable } from '@angular/core';
import {
  CenterNoticePermissions,
  CenterTemplatePermissions,
  CenterUserInvitePermissions,
  CenterUserPermissions,
  ChildPermissions,
  DefaultPermissions,
  SchedulePermissions,
} from '@malirang/common';
import { BaseStore } from '@malirang/front-share';
import { CenterUserStore } from './user.store';

@Injectable({ providedIn: 'root' })
export class CenterRoleStore extends BaseStore {
  private readonly centerUserStore = inject(CenterUserStore);
  private centerUser = this.centerUserStore.currentCenterUser;

  /**
   * 현재 센터의 나의 권한
   */
  myRole = computed(() => this.centerUser()?.role);

  /**
   * 센터 삭제 권한
   */
  centerDeleteRole = computed(() =>
    this.myRole()?.permissions.includes(DefaultPermissions.CENTER_DELETE),
  );

  /**
   * 센터 수정 권한
   */
  centerUpdateRole = computed(() =>
    this.myRole()?.permissions.includes(DefaultPermissions.CENTER_UPDATE),
  );

  /**
   * 센터 대표 위임 권한
   */
  centerDelegateRole = computed(() =>
    this.myRole()?.permissions.includes(DefaultPermissions.CENTER_DELEGATE),
  );

  /**
   * 센터 사용자 초대 권한
   */
  centerUserInviteRole = computed(() =>
    this.myRole()?.permissions.includes(
      CenterUserInvitePermissions.CENTER_USER_INVITE,
    ),
  );

  /**
   * 센터 구성원 역할 수정 권한
   */
  centerUserRoleUpdateRole = computed(() =>
    this.myRole()?.permissions.includes(
      CenterUserPermissions.CENTER_USER_ROLE_UPDATE,
    ),
  );

  /**
   * 센터 사용자 추방 권한
   */
  centerUserKickRole = computed(() =>
    this.myRole()?.permissions.includes(CenterUserPermissions.CENTER_USER_KICK),
  );

  /**
   * 센터 사용자 가입 승인/반려 권한
   */
  centerUserApproveRole = computed(() =>
    this.myRole()?.permissions.includes(
      CenterUserPermissions.CENTER_USER_APPROVE,
    ),
  );

  /**
   * 센터 사용자 그룹 관리 권한
   */
  centerUserGroupManageRole = computed(() =>
    this.myRole()?.permissions.includes(
      CenterUserPermissions.CENTER_USER_GROUP_MANAGE,
    ),
  );

  /**
   * 일정 등록/수정 권한
   */
  scheduleEditRole = computed(() =>
    this.myRole()?.permissions.includes(SchedulePermissions.SCHEDULE_EDIT),
  );

  /**
   * 일정 삭제 권한
   */
  scheduleDeleteRole = computed(() =>
    this.myRole()?.permissions.includes(SchedulePermissions.SCHEDULE_DELETE),
  );

  /**
   * 아동 등록/수정 권한
   */
  childEditRole = computed(() =>
    this.myRole()?.permissions.includes(ChildPermissions.CHILD_EDIT),
  );

  /**
   * 아동 삭제 권한
   */
  childDeleteRole = computed(() =>
    this.myRole()?.permissions.includes(ChildPermissions.CHILD_DELETE),
  );

  noticeEditRole = computed(() =>
    this.myRole()?.permissions.includes(
      CenterNoticePermissions.CENTER_NOTICE_EDIT,
    ),
  );

  noticeDeleteRole = computed(() =>
    this.myRole()?.permissions.includes(
      CenterNoticePermissions.CENTER_NOTICE_DELETE,
    ),
  );

  templateEditRole = computed(() =>
    this.myRole()?.permissions.includes(
      CenterTemplatePermissions.CENTER_TEMPLATE_EDIT,
    ),
  );

  templateDeleteRole = computed(() =>
    this.myRole()?.permissions.includes(
      CenterTemplatePermissions.CENTER_TEMPLATE_DELETE,
    ),
  );

  constructor() {
    super(null);
  }
}
